import camelize from 'camelcase-keys-deep';

export default class Adjudication {
  constructor(data) {
    const props = camelize(data);
    Object.assign(this, props);
  }

  lot() {
    return this.env().Lot.getById(this.lotId);
  }

  user() {
    return this.env().User.getById(this.userId);
  }

  linked() {
    return this.env().LinkedAdjudication.findBy('currentId', this.id);
  }
}
